module.exports = {
	"config": {
		"siteTitle": "Alex Maroz - Full Stack Developer for hire",
		"siteDescr": "Alex Maroz Full Stack Developer for hire for hire, remote, onsite and outsourced development.",
		"siteKeywords": "asp.net,aws, azure,digitalocean,sql,c#,entity framework,html5,css3,javascript,reactjs,react,vue,vuejs,angular2,angular4,microsoft,golang,nodejs,node,postgres,mongodb,mssql,redis,microservices,docker,kubernetes,rancher,ci/cd,1099,corp-corp,contractor,remote",
		"siteAuthor": "Alex Maroz - Sr. Fullstack Developer: NodeJS, ReactJS, VueJS, Angular4, ASP.NET Core, Golang, MongoDB, Postgres, SQL, Docker, Kubernetes, CI/CD",
		"siteLinkedInUrl": "https://www.linkedin.com/in/alexmaroz/",
		"siteTwitterUrl": "http://twitter.com/alexmaroz",
		"siteGithubUrl": "https://github.com/AlexMaroz",
		"siteEmailUrl": "contact@alexmaroz.com",
		"sitePhone": "+1 (240) 583-0382",
		"sitePhonePlain": "+12405830382",
		"siteWebsiteUrl": "www.alexmaroz.com",
		"siteRssUrl": "#",
		"siteVkUrl": "#",
		"gtmId": "G-3M0M31DGCF",
		"linkPrefix": "/"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 387
// module chunks = 0